// extracted by mini-css-extract-plugin
export default {"icon":"Info_icon__f5tU0","tooltip":"Info_tooltip__Jlrbx","dialog":"Info_dialog__Ahr3z"};